import { Controller } from "@hotwired/stimulus"

// Opens an enlarged image overlay on the same page. Smooth open/close + loading state.
export default class extends Controller {
  static targets = ["overlay", "image", "caption", "loading"]

  open(event) {
    event.preventDefault()
    const url = event.currentTarget.dataset.lightboxUrlParam
    const label = event.currentTarget.dataset.lightboxLabelParam || ""
    if (!url || !this.hasImageTarget) return

    this.imageTarget.src = ""
    this.imageTarget.alt = label
    if (this.hasCaptionTarget) this.captionTarget.textContent = label
    if (this.hasLoadingTarget) this.loadingTarget.classList.remove("hidden")

    this.overlayTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")

    requestAnimationFrame(() => {
      this.overlayTarget.classList.add("lightbox-open")
    })

    const img = new Image()
    img.onload = () => {
      this.imageTarget.src = url
      this.imageTarget.alt = label
      if (this.hasLoadingTarget) this.loadingTarget.classList.add("hidden")
    }
    img.onerror = () => {
      if (this.hasLoadingTarget) this.loadingTarget.classList.add("hidden")
      this.imageTarget.src = url
    }
    img.src = url
  }

  close(event) {
    if (event) event.preventDefault()
    this.overlayTarget.classList.remove("lightbox-open")
    this.overlayTarget.classList.add("lightbox-closing")
    setTimeout(() => {
      this.overlayTarget.classList.add("hidden")
      this.overlayTarget.classList.remove("lightbox-closing")
      document.body.classList.remove("overflow-hidden")
      this.imageTarget.src = ""
    }, 250)
  }

  closeOnBackdrop(event) {
    if (event.target === this.overlayTarget) this.close(event)
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.close(event)
  }
}
